const innsynSitePaths = {
  shortUrl: "/innsyn",
  ileggelser: {
    shortUrl: "/innsyn/ileggelser",
    oversikt: "/innsyn/ileggelser/oversikt",
    detalj: {
      shortUrl: "/innsyn/ileggelser/:id",
      rediger: "/innsyn/ileggelser/:id/bilder/:bildeId/rediger",
      bilde: "/innsyn/ileggelser/:id/bilder/:bildeId",
    },
  },
  miljogebyrer: {
    shortUrl: "/innsyn/miljogebyrer",
    oversikt: "/innsyn/miljogebyrer/oversikt",
    detalj: {
      shortUrl: "/innsyn/miljogebyrer/:id",
      rediger: "/innsyn/miljogebyrer/:id/bilder/:bildeId/rediger",
      bilde: "/innsyn/miljogebyrer/:id/bilder/:bildeId",
      miljokontroll: {
        rediger:
          "/innsyn/miljogebyrer/:miljogebyrId/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId/rediger",
        bilde:
          "/innsyn/miljogebyrer/:miljogebyrId/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId",
      },
    },
  },
  inntauing: "/innsyn/inntauing",
  motorvogn: {
    shortUrl: "/innsyn/motorvogn",
    utskrift: "/innsyn/motorvogn/utskrift",
  },
  personopplysninger: "/innsyn/personopplysninger",
};

export default innsynSitePaths;
